import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Deal, IDeal, PaginateResponse } from '@tacliatech/types';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DealSearchService {
  constructor(private http: HttpClient) {}

  search(
    query: { [key: string]: any } = {},
    options = {
      automaticallyHandleCancelled: true,
    }
  ) {
    if (
      !Object.prototype.hasOwnProperty.call(query, 'takeCancelled') &&
      options.automaticallyHandleCancelled
    ) {
      query.takeCancelled = false;
    }

    const params = new HttpParams({
      fromObject: {
        ...query,
      },
    });

    return this.http
      .get<PaginateResponse<Deal.Output[]>>(`:API_URL/search/deals`, {
        params,
        headers: {
          ['X-API-Version']: '2',
        },
      })
      .pipe(
        map((res) => {
          let docs = res?.docs ? res.docs : [];

          // @ts-ignore
          docs = docs.map((el) => {
            return {
              ...el,
            };
          });

          return {
            ...res,
            docs,
          };
        })
      );
  }

  report(query: { [key: string]: any } = {}) {
    const params = new HttpParams({
      fromObject: {
        ...query,
      },
    });

    return this.http.get<PaginateResponse<IDeal[]>>(
      `:API_URL/search/dealsreport`,
      {
        params,
      }
    );
  }
}
